/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect, useRef, useMemo } from 'react';
import { getDocumentAsync } from 'expo-document-picker';
import { useDispatch, useSelector } from 'react-redux';
import {
  View,
  StyleSheet,
  ScrollView,
  Dimensions,
  TouchableOpacity,
} from 'react-native';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Toast from 'react-native-toast-message';
import * as Layout from '@components/screen/Layout';
import Colors from '@global/colors';
import {
  isWeb,
  isMobileWeb,
  isIos,
  isAndroid,
  isNative,
} from '@global/screens';
import {
  convertFullAddress,
  currency,
  uploadS3,
  downloadFile,
  isQuotationAmountDiff,
  parseDate,
  isAllowedAttachmentFormat,
} from '@global/helpers';
import ModalUpload from '@components/modal/ModalUpload';
import SociollaText from '@components/sociolla/SociollaText';
import ModalFull from '@components/modal/ModalFull';
import ScrollContainer from '@components/global/ScrollContainer';
import Button from '@components/form/Button';
import ProgressBar from '@components/global/ProgressBar';
import ItemDetail from '@components/global/ItemDetail';
import Image from '@components/global/Image';
import Divider from '@components/global/Divider';
import Input from '@components/form/Input';
import SelectBox from '@components/form/SelectBox';
import InputLoading from '@components/form/InputLoading';
import CustomerSearch from '@components/form/search/CustomerReturnSearch';
import PriceRulesSearch from '@components/form/search/PriceRulesSearch';
import SalesTeamSearch from '@components/form/search/SalesTeamSearch';
import SalesPersonSearch from '@components/form/search/SalesPersonSearch';
import PromotionRulesSearch from '@components/form/search/PromotionRulesSearch';
import DatePicker from '@components/form/DatePicker';
import Alert from '@components/global/Alert';
import Discard from '@components/global/Discard';
import ProductItem from '@components/global/ProductItem';
import AddProduct from '@/screens/transaction/sales-order/components/AddProduct';
import RemoveImage from '@/screens/sales-activity/components/todo-list/on-going/image/RemoveImage';
import { SociollaCheckbox } from '@components/sociolla/form';
import FormLabel from '@components/form/common/FormLabel';

import useApi from '@/hooks/useApi';
import { MsOrder } from '@api/ms-order';
import { MsAccount } from '@api/ms-account';
import { MsB2b } from '@api/ms-b2b';
import { showAlert, showDiscard, hideDiscard } from '@/store/global';
import { showPopup } from '@/store/modal';
import { filterAdded } from '@/store/params';
import { logEvent } from '@global/analytics';
import WarehouseSearch from '@components/form/search/WarehouseSearch';
import templateSoProduct from '@/assets/csv/template_import_product_order';
import {
  ORDER_TYPE,
  SPREADING_ORDER_TYPE,
  CONSIGNMENT_ORDER_TYPE,
  ATTACHMENT_FORMAT_ERROR_TITLE,
  ATTACHMENT_FORMAT_ERROR_DESCRIPTION,
} from '@/constants';

const TitleSectionForm = ({
  title,
  showButton = true,
  buttonTitle,
  disabled = false,
  onCallback,
  buttonTitleChild = '',
  onCallbackChild = () => {},
}) => {
  return (
    <View
      style={{
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: Colors.grey4,
        paddingHorizontal: 20,
        paddingVertical: 12,
      }}>
      <SociollaText
        type="bold"
        style={{
          fontSize: isWeb ? 16 : 13,
          letterSpacing: 0.5,
          color: Colors.grey1,
        }}>
        {title}
      </SociollaText>
      {showButton ? (
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
          }}>
          {buttonTitleChild ? (
            <Button
              type="default"
              rounded
              buttonStyle={{
                width: isWeb ? 150 : 85,
                marginRight: showButton ? 10 : 0,
              }}
              title={
                <SociollaText
                  type="bold"
                  style={{
                    fontSize: isWeb ? 14 : 13,
                    letterSpacing: 0.5,
                    color: Colors.black,
                  }}>
                  {buttonTitleChild}
                </SociollaText>
              }
              onPress={onCallbackChild}
            />
          ) : (
            false
          )}
          <Button
            type="default"
            rounded
            buttonStyle={{ width: isWeb ? 150 : 85 }}
            disabledStyle={{ width: isWeb ? 150 : 85 }}
            disabled={disabled}
            title={
              <SociollaText
                type="bold"
                style={{
                  fontSize: isWeb ? 14 : 13,
                  letterSpacing: 0.5,
                  color: Colors.black,
                }}>
                {buttonTitle}
              </SociollaText>
            }
            onPress={onCallback}
          />
        </View>
      ) : (
        false
      )}
    </View>
  );
};

const dimension = Dimensions.get('screen');
const limit = 10;
const BUSINESS_TYPE_SPREADING = [814, 496]; // Filter customer by business type spreading if sales order spreading

const SalesOrderFormScreen = (props) => {
  const formRef = useRef();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth.user);
  const menuPermission = useSelector((state) => state.auth.menuPermission);
  const showImportModalSOProduct = useSelector(
    (state) => !!state.modal.showImportModalSOProduct,
  );
  const userRole = userData?.role?.code;
  const userSalesTeam = userData?.sales_team || [];

  const totalPage = 2;
  const [isSubmit, setIsSubmit] = useState(false);
  const [bulkProductFile, setBulkProductFile] = useState(null);
  const [page, setPage] = useState(1);
  const [showAddProduct, setShowAddProduct] = useState(false);
  const [productDetail, setProductDetail] = useState({});
  const [detailData, setDetailData] = useState({});
  const [selectedRegularDiscount, setSelectedRegularDiscount] = useState({});
  const [selectedCashBeforeDelivery, setSelectedCashBeforeDelivery] = useState(
    {},
  );
  const [selectedCustomer, setSelectedCustomer] = useState({});
  const [selectedSalesTeam, setSelectedSalesTeam] = useState({});
  const [userWarehouse, setUserWarehouse] = useState({});
  const [branchCode, setBranchCode] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const [isAvailableEdit, setIsAvailableEdit] = useState(false);
  const [priceRulesChange, setPriceRulesChange] = useState(false);
  const [isLoadingCluster, setIsLoadingCluster] = useState(false);
  const [isLoadingCustomer, setIsLoadingCustomer] = useState(false);
  const [isDisabledPoNumber, setIsDisabledPoNumber] = useState(false);
  const [loadingAddProduct, setLoadingAddProduct] = useState(false);
  const [RulesTaxTypes, setRulesTaxTypes] = useState('');
  const [isQuotation, setIsQuotation] = useState(false);
  // TODO: Remove on Consignment Phase 2
  const [isConsignment, setIsConsignment] = useState(false);

  const [priceRulesId, setPriceRulesId] = useState('');
  const [invoiceAddress, setInvoiceAddress] = useState([]);
  const [deliveryAddress, setDeliveryAddress] = useState([]);
  const [products, setProducts] = useState([]);
  const [detailCustomerCluster, setDetailCustomerCluster] = useState({});
  const [productCount, setProductCount] = useState(0);
  const [detailPromoData, setDetailPromoData] = useState(null);
  const [gwpProductOption, setGwpProductOption] = useState(null);
  const [indexGwpProduct, setIndexGwpProduct] = useState(null);
  const [productPromo, setProductPromo] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [customerChanged, setCustomerChanged] = useState(false);

  const [subTotal, setSubTotal] = useState(0);
  const [taxes, setTaxes] = useState(0);
  const [total, setTotal] = useState(0);
  const [skip, setSkip] = useState(0);

  const getSalesOrderDetail = useApi(MsOrder.getSalesOrderDetail);
  const getSalesOrderCount = useApi(MsOrder.getSalesOrderCount);
  const getPromotionRulesDetail = useApi(MsOrder.getPromotionRulesDetail);
  const getRegularDiscount = useApi(MsOrder.getRegularDiscount);
  const getCustomerId = useApi(MsAccount.getCustomerId);
  const getClusterByCustomerId = useApi(MsAccount.getClusterByCustomerId);
  const getSalesTeamDetail = useApi(MsB2b.getSalesTeamDetail);

  const isSpreading = useMemo(() => {
    if (isEdit) {
      return detailData.type == 'spreading';
    }
    const isSpread = props?.route?.params?.order_type == 'spreading';
    if (isSpread) {
      return true;
    }
    return false;
  }, [props.route.params, isEdit, detailData]);

  const isConsignmentForm = useMemo(() => {
    if (isEdit) {
      return detailData.type == 'consignment';
    }
    const isCons = props?.route?.params?.order_type == 'consignment';
    if (isCons) {
      return true;
    }
    return false;
  }, [props.route.params, isEdit, detailData]);

  const orderTypeOptions = useMemo(() => {
    if (isSpreading) {
      return SPREADING_ORDER_TYPE;
    }
    if (isConsignmentForm) {
      return CONSIGNMENT_ORDER_TYPE;
    }
    return ORDER_TYPE;
  }, [isSpreading, isConsignmentForm]);

  const orderId = useMemo(() => {
    return props?.route?.params?.id || '';
  }, [props.route.params]);

  const activityId = useMemo(() => {
    return props?.route?.params?.activityId || '';
  }, [props.route.params]);

  const taskDeliveryAddress = useMemo(() => {
    return props?.route?.params?.deliveryAddress || '';
  }, [props?.route?.params]);

  const taskId = useMemo(() => {
    return props?.route?.params?.taskId || '';
  }, [props.route.params]);

  const isFromActivity = useMemo(() => {
    return Boolean(props?.route?.params?.customerActivityId || '');
  }, [props.route.params]);

  const getCustomer = async (id, name = '') => {
    if (id) {
      const response = await getCustomerId.request(id);
      const result = response.data.data;
      if (result._id) {
        result.id = result._id;
      }
      return result;
    }
    return null;
  };

  const getDetail = async (id) => {
    const response = await getSalesOrderDetail.request(id);
    if (response?.data?.data && Object.keys(response.data.data).length) {
      const result = response.data.data;
      setDetailData(result);
      getProductSalesOrder(id);
      setSubTotal(result.subtotal);
      setTaxes(result.total_tax_amount);
      setTotal(result.total_amount);
      setIsQuotation(result.is_quotation);
    } else {
      setDetailData({});
      setSubTotal(0);
      setTaxes(0);
      setTotal(0);
    }
    setTimeout(() => {
      setIsReady(true);
    }, 500);
  };

  const getUserSalesTeamDetail = async (id) => {
    const response = await getSalesTeamDetail.request(id);
    if (response?.data?.data) {
      setUserWarehouse(response?.data?.data.warehouse);
    }
  };

  const updateDetail = async (id) => {
    try {
      const response = await MsOrder.getSalesOrderDetail(id);
      if (response?.data?.data && Object.keys(response.data.data).length) {
        const result = response.data.data;
        setDetailData(result);
        setSubTotal(result.subtotal);
        setTaxes(result.total_tax_amount);
        setTotal(result.total_amount);
        await getProductSalesOrder(id);
      } else {
        setDetailData({});
        setSubTotal(0);
        setTaxes(0);
        setTotal(0);
      }
    } catch (error) {
      console.log('error-update-detail', error);
    }
  };

  const getProductSalesOrder = async (id, newSkip = 0) => {
    setSkip(newSkip);
    const isMore = newSkip > 0;
    const response = await MsOrder.getProductSalesOrder(id, {
      params: {
        skip: newSkip,
        limit: limit,
      },
    });
    if (response?.data?.data?.length) {
      const result = response.data.data;
      let finalResult = JSON.parse(JSON.stringify(products));
      if (isMore) {
        const arr = [];
        const tempFinal = finalResult.concat(result);
        for (let i = 0; i < tempFinal.length; i++) {
          const item = tempFinal[i];
          if (
            !arr.find(
              (a) =>
                a?.id == item?.id &&
                a?.combination?.id == item?.combination?.id,
            )
          ) {
            arr.push(item);
          }
        }
        finalResult = arr;
      } else {
        finalResult = result;
      }
      setProducts(finalResult);
      // getBuyXGetXDiscount(finalResult);
      if (!isMore && !isWeb && props?.route?.params?.firstAdded) {
        setPage(2);
      }
    } else {
      if (!isMore) {
        setProducts([]);
      }
    }

    const responseCount = await MsOrder.getProductCountSalesOrder(id);
    if (responseCount?.data?.data) {
      const resultCount = responseCount.data.data;
      setProductCount(resultCount);
    }
  };

  // get regular discount
  const getRegularDiscountDetail = async (id) => {
    if (id) {
      const response = await getPromotionRulesDetail.request(id);
      if (
        response.status == 200 &&
        response?.data?.data &&
        Object.keys(response.data.data).length
      ) {
        const result = response.data.data;
        result.id = result._id;
        setSelectedRegularDiscount(result);
      } else {
        setSelectedRegularDiscount({});
      }
    }
  };

  // get regular discount limit 1 after choose customer
  const getRegularDiscountCustomer = async (id) => {
    if (id) {
      const response = await getRegularDiscount.request({
        params: { filter: { cluster_id: id } },
      });
      if (formRef.current) {
        const regularCustomer =
          response.status == 200 ? response?.data?.data : null;
        if (regularCustomer) {
          regularCustomer.id = regularCustomer._id;
          setSelectedRegularDiscount(regularCustomer);
          formRef.current.setFieldValue('regular_discount', {
            id: regularCustomer._id,
            name: regularCustomer.name,
          });
        } else {
          setSelectedRegularDiscount({});
          formRef.current.setFieldValue('regular_discount', null);
        }
      }
    }
  };

  // get cash before delivery
  const getCashBeforeDeliveryDetail = async (id) => {
    if (id) {
      const response = await getPromotionRulesDetail.request(id);
      if (
        response.status == 200 &&
        response?.data?.data &&
        Object.keys(response.data.data).length
      ) {
        const result = response.data.data;
        result.id = result._id;
        setSelectedCashBeforeDelivery(result);
      } else {
        setSelectedCashBeforeDelivery({});
      }
    }
  };

  // get customer cluster list based on customer cluster
  const getCustomerCluster = async (id) => {
    setIsLoadingCluster(true);
    const customer_cluster = await getClusterByCustomerId.request(id, {
      params: { filter: { _id: id }, limit: 1 },
    });
    if (
      customer_cluster?.data?.data &&
      Object.keys(customer_cluster.data.data).length
    ) {
      const result = customer_cluster.data.data;
      if (isEdit ? !formRef.current?.values?.regular_discount?.id : true) {
        getRegularDiscountCustomer(result?.cluster?.id);
      }
      setDetailCustomerCluster(result);
      setIsLoadingCluster(false);
    } else {
      setDetailCustomerCluster({});
      setIsLoadingCluster(false);
    }
  };

  // get customer po number for gt market type
  const getCustomerPoNumber = async (id) => {
    setIsDisabledPoNumber(true);
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      const response = await MsAccount.getCustomerPoNumber(id);
      if (response?.data?.data) {
        if (formRef.current) {
          formRef.current.setFieldValue(
            'customer_po_number',
            response.data.data,
          );
        }
      } else {
        Toast.show({
          text1: 'Failed to generate Customer PO number.',
          type: 'error',
        });
      }
      dispatch(showPopup({ name: 'isLoading', value: false }));
    } catch (err) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
    }
  };

  const resetData = () => {
    setSkip(0);
    setIsDisabledPoNumber(false);
    setIsSubmit(false);
    setBulkProductFile(null);
    setIsReady(false);
    setIsAvailableEdit(false);
    setIsEdit(false);
    setLoadingAddProduct(false);
    setPriceRulesChange(false);
    setShowAddProduct(false);
    setPage(1);
    setSubTotal(0);
    setTaxes(0);
    setTotal(0);
    setBranchCode('');
    setPriceRulesId('');
    setProducts([]);
    setInvoiceAddress([]);
    setDeliveryAddress([]);
    setDetailData({});
    setSelectedCustomer({});
    setSelectedSalesTeam({});
    setSelectedRegularDiscount({});
    setSelectedCashBeforeDelivery({});
    setDetailCustomerCluster({});
  };

  const onDownloadAttachment = (url) => {
    if (url) {
      downloadFile(url, 'sales-order-document', '', true);
    }
  };

  const goToActivity = () => {
    props.navigation.navigate('SalesActivityNavigator');
  };

  // handle back button
  const goBack = () => {
    if (orderId) {
      props.navigation.navigate('SalesOrderDetailScreen', props.route.params);
    } else if (activityId && taskId) {
      goToActivity();
    } else {
      props.navigation.navigate('SalesOrderScreen');
    }
  };

  // show discard popup when click back button
  const needToBack = (e = null) => {
    const btnStyle = {
      width: isWeb ? 100 : 220,
      marginHorizontal: isWeb ? 5 : 0,
      marginBottom: 10,
    };
    dispatch(
      showDiscard({
        show: true,
        title: 'Discard',
        description: 'Unsaved data will be deleted. Do you want to proceed?',
        buttons: [
          {
            type: 'main',
            style: btnStyle,
            textColor: Colors.white,
            text: 'OK',
            callback: () => {
              if (
                !isWeb &&
                props?.route?.params?.firstAdded &&
                detailData?._id
              ) {
                props.navigation.replace('SalesOrderFormScreen', {
                  titleScreen: detailData.reference_code,
                  name: detailData.name,
                  id: detailData._id,
                });
              }
              if (e?.data?.action) {
                props.navigation.dispatch(e.data.action);
              } else {
                goBack();
              }
              dispatch(hideDiscard());
            },
          },
          {
            type: 'default',
            style: btnStyle,
            textColor: Colors.black,
            text: 'Save Draft',
            callback: () => {
              dispatch(hideDiscard());
              if (formRef.current) {
                formRef.current.handleSubmit();
              }
            },
          },
          {
            type: 'default',
            style: btnStyle,
            textColor: Colors.black,
            text: 'Cancel',
            callback: () => dispatch(hideDiscard()),
          },
        ],
      }),
    );
  };

  // TODO: Remove on Consignment Phase 2
  useEffect(() => {
    setIsConsignment(isConsignmentForm);
  }, [isConsignmentForm]);

  // change left button
  useEffect(() => {
    props.navigation.setOptions({
      headerLeft: () => <Layout.BackCustom onCallback={() => goBack()} />,
    });
  }, []);

  // detect route change
  useEffect(() => {
    props.navigation.addListener('beforeRemove', (e) => {
      if (!isSubmit && isReady) {
        needToBack(e);
      }
    });
    return () => {
      props.navigation.removeListener('beforeRemove');
    };
  }, [props.navigation, isSubmit]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (!menuPermission.find((permit) => permit == 'OrderCreate')) {
        Toast.show({
          text1: 'You have no permission for this page',
          type: 'error',
        });
        setTimeout(() => {
          props.navigation.navigate('HomeNavigator', {
            screen: 'HomeScreen',
          });
        }, 500);
      } else {
        if (!bulkProductFile) {
          resetData();
        }
        if (orderId) {
          setIsEdit(true);
          getDetail(orderId);
        } else {
          setIsEdit(false);
          setTimeout(() => {
            setIsReady(true);
            if (props?.route?.params?.customerActivityId) {
              getDetailCustomer(props.route.params.customerActivityId);
            }
          }, 500);
        }
      }
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (userSalesTeam?.length) {
        getUserSalesTeamDetail(userSalesTeam?.[0]?.id);
      }
    }
    return () => {
      mounted = false;
    };
  }, [userSalesTeam]);

  // form validation for sales order
  const FormValidationSchema = Yup.object().shape({
    customer: Yup.object().required('Customer is required.'),
    invoice_address: Yup.object()
      .required('Invoice address is required.')
      .when('status', (status) => {
        if (status != 'draft') {
          return Yup.object().required('Invoice address is required.');
        }
        return Yup.object();
      }),
    delivery_address: Yup.object()
      .required('Delivery address is required.')
      .when('status', (status) => {
        if (status != 'draft') {
          return Yup.object().required('Delivery address is required.');
        }
        return Yup.object();
      }),
    sales_person: Yup.object()
      .required('Sales person is required.')
      .when('status', (status) => {
        if (status != 'draft') {
          return Yup.object().required('Sales person is required.');
        }
        return Yup.object();
      }),
    sales_team: Yup.object()
      .required('Sales team is required.')
      .when('status', (status) => {
        if (status != 'draft') {
          return Yup.object().required('Sales team is required.');
        }
        return Yup.object();
      }),
    expiration_date: Yup.string()
      .required('Expiration date is required.')
      .when('status', (status) => {
        if (status != 'draft') {
          return Yup.string().required('Expiration date is required.');
        }
        return Yup.string();
      }),
    pricelist: Yup.object()
      .required('Pricelist is required.')
      .when('status', (status) => {
        if (status != 'draft') {
          return Yup.object().required('Pricelist is required.');
        }
        return Yup.object();
      }),
    customer_po_number: Yup.string()
      .required('Customer PO number is required.')
      .when('status', (status) => {
        if (status != 'draft') {
          return Yup.string().required('Customer PO number is required.');
        }
        return Yup.string();
      }),
    customer_po_date: Yup.string()
      .required('Customer PO date is required.')
      .when('status', (status) => {
        if (status != 'draft') {
          return Yup.string().required('Customer PO date is required.');
        }
        return Yup.string();
      }),
    delivered_at: Yup.string()
      .required('Delivery date is required.')
      .when('status', (status) => {
        if (status != 'draft') {
          return Yup.string().required('Delivery date is required.');
        }
        return Yup.string();
      }),
    notes: Yup.string(),
  });

  // show add product popup
  const onAddProduct = (val = {}) => {
    if (customerChanged) {
      dispatch(
        showAlert({
          show: true,
          title: 'Sales Order',
          description: 'Please save sales order first before adding product',
          isConfirm: false,
        }),
      );
      return;
    }
    if (
      (val?.sell_out || val?.buffer || val?.current_stock) &&
      !val?.estimation_order_value
    ) {
      const sell_out = val.sell_out || 0;
      const bufferCalc = sell_out > 0 ? Math.ceil(sell_out / 2) : 0;
      const current_stock = val.current_stock || 0;
      val.estimation_order_value = sell_out + bufferCalc - current_stock;
      val.buffer = bufferCalc;
    }
    setProductDetail(val);
    setShowAddProduct(true);
  };

  // show add product popup
  const onCloseProduct = () => {
    setProductDetail({});
    setShowAddProduct(false);
  };

  // remove product from sales order form with popup confirmation
  const onRemoveProduct = (index) => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    dispatch(
      showAlert({
        show: true,
        title: 'Remove Product',
        description: 'This product will be deleted. Do you want to proceed?',
        testID: 'sales-order-form-remove-product',
        onCallback: async () => {
          dispatch(showPopup({ name: 'isLoading', value: true }));
          const pr = JSON.parse(JSON.stringify(products));
          const removeItem = JSON.parse(JSON.stringify(pr[index]));
          pr.splice(index, 1);
          setProducts(pr);
          try {
            await MsOrder.removeProductSalesOrder(
              detailData?._id,
              removeItem?.id,
              removeItem?.combination?.id,
            );
            await updateDetail(detailData?._id);
          } catch (error) {}
          dispatch(showPopup({ name: 'isLoading', value: false }));
        },
      }),
    );
    dispatch(showPopup({ name: 'isLoading', value: false }));
  };

  // change filter
  const onChangeFilter = () => {
    dispatch(filterAdded({ status: 'need_approval' }));
  };

  const getDetailCustomer = (customerId) => {
    setIsLoadingCustomer(true);
    Promise.all([getCustomer(customerId), getCustomerCluster(customerId)])
      .then(([customer, cluster]) => {
        if (customer?.id || customer?._id) {
          setSelectedCustomer({
            id: customer.id,
            name: customer.name,
            market_type: customer.market_type,
            special_discount: customer.special_discount || 0,
            cluster: customer.cluster,
            customer_type: customer.customer_type || '',
          });
          if (isFromActivity && formRef.current) {
            formRef.current.setFieldValue('customer', customer);
            if (
              customer?.market_type?.code?.toLowerCase() == 'gt' &&
              customer?.user?.id
            ) {
              formRef.current.setFieldValue('sales_person', customer.user);
              getCustomerPoNumber(customer.id);
            }
            if (customer?.user?.branch_code) {
              setBranchCode(customer.user.branch_code);
            }
          }
          // getCustomerCluster(customer.id);
          if (customer?.invoice_address?.length) {
            const invoices = customer.invoice_address.map((item) => {
              if (item._id) {
                item.id = item._id;
              }
              return item;
            });
            setInvoiceAddress(invoices);
            if (
              detailData?.invoice_address &&
              Object.keys(detailData.invoice_address).length
            ) {
              const findAddr = invoices.find(
                (a) => a._id == detailData.invoice_address.id,
              );
              if (findAddr && formRef.current) {
                formRef.current.setFieldValue('invoice_address', findAddr);
              }
            } else {
              if (isFromActivity && invoices?.length == 1 && formRef.current) {
                formRef.current.setFieldValue('invoice_address', invoices[0]);
              }
            }
          }
          if (customer?.delivery_address?.length) {
            // TODO: Filter by order type on Consignment Phase 2
            const deliveries = customer.delivery_address.map((item) => {
              if (item._id) {
                item.id = item._id;
              }
              return item;
            });
            setDeliveryAddress(deliveries);
            if (
              detailData?.delivery_address &&
              Object.keys(detailData.delivery_address).length
            ) {
              const findAddr = deliveries.find(
                (a) => a._id == detailData.delivery_address.id,
              );
              if (findAddr && formRef.current) {
                formRef.current.setFieldValue('delivery_address', findAddr);
              }
            } else {
              if (
                isFromActivity &&
                deliveries?.length == 1 &&
                formRef.current
              ) {
                formRef.current.setFieldValue(
                  'delivery_address',
                  deliveries[0],
                );
              }
            }
          }
          if (
            customer?.market_type?.code?.toLowerCase() == 'gt' &&
            customer?.sales_team?.warehouse?.id &&
            formRef.current
          ) {
            setSelectedSalesTeam(customer.sales_team);
            formRef.current.setFieldValue('sales_team', customer.sales_team);
          }
        } else {
          if (
            selectedRegularDiscount?._id ||
            selectedRegularDiscount?.id ||
            detailCustomerCluster?._id ||
            detailCustomerCluster?.id
          ) {
            setSelectedRegularDiscount({});
            setDetailCustomerCluster({});
          }
        }
        setIsLoadingCustomer(false);
      })
      .catch((err) => {
        setIsLoadingCustomer(false);
      });
  };

  // process initial form sales order
  useEffect(() => {
    let mounted = true;
    if (mounted && isReady && isEdit && detailData) {
      if (detailData?.price_list?.id) {
        setPriceRulesId(detailData.price_list.id);
        setRulesTaxTypes(detailData?.price_list?.taxes_type);
        formRef.current.setFieldValue('pricelist', {
          id: detailData.price_list.id,
          name: detailData?.price_list?.name,
          taxes_type: detailData?.price_list?.taxes_type,
        });
      }
      if (
        detailData.regular_discount?.id &&
        !Object.keys(selectedRegularDiscount)?.length
      ) {
        getRegularDiscountDetail(detailData.regular_discount.id);
        if (formRef.current) {
          formRef.current.setFieldValue(
            'regular_discount',
            detailData.regular_discount,
          );
        }
      }
      if (
        detailData.cash_before_delivery?.id &&
        !Object.keys(selectedCashBeforeDelivery)?.length
      ) {
        getCashBeforeDeliveryDetail(detailData.cash_before_delivery.id);
        if (formRef.current) {
          formRef.current.setFieldValue(
            'cash_before_delivery',
            detailData.cash_before_delivery,
          );
        }
      }
      if (detailData.user) {
        if (detailData.user.branch_code) {
          setBranchCode(detailData.user.branch_code);
        }
        if (detailData.user.team_id) {
          setSelectedSalesTeam({
            id: detailData.user.team_id,
            name: detailData.user.team_name,
            warehouse: detailData?.user?.team_warehouse?.id
              ? detailData.user.team_warehouse
              : '',
          });
        }
      }
      if (
        detailData?.user?.team_id &&
        detailData?.user?.team_warehouse?.id &&
        formRef.current
      ) {
        const selectedST = {
          id: detailData?.user?.team_id,
          name: detailData?.user?.team_name,
          warehouse: detailData?.user?.team_warehouse,
        };
        setSelectedSalesTeam(selectedST);
        formRef.current.setFieldValue('sales_team', selectedST);
      }
      if (detailData.customer && Object.keys(detailData.customer).length) {
        getDetailCustomer(detailData?.customer?.id);
      }
      setTimeout(() => {
        setIsAvailableEdit(true);
      }, 500);
    }
    return () => {
      mounted = false;
    };
  }, [isReady, isEdit, detailData]);

  const isFilledDeliveryAddress = (val) => {
    return (
      val?.delivery_address?.id ||
      val?.delivery_address?._id ||
      (val?.delivery_address && Object.keys(val.delivery_address).length)
    );
  };

  // show add product button when customer and pricelist has been filled and status if draft or all mandatory field has been filled
  const showAddProductButton = (val) => {
    return Boolean(
      !isQuotation &&
        val.customer &&
        val.pricelist &&
        (val == 'draft'
          ? true
          : val.invoice_address &&
            val.sales_person &&
            val.sales_team &&
            val.expiration_date &&
            val.customer_po_number &&
            val.customer_po_date &&
            val.delivered_at &&
            isFilledDeliveryAddress(val)),
    );
  };

  // condition for request confirmation button
  const isAvailableSubmit = (val) => {
    return Boolean(
      val.customer &&
        val.pricelist &&
        val.invoice_address &&
        val.sales_person &&
        val.sales_team &&
        val.expiration_date &&
        val.customer_po_number &&
        val.customer_po_date &&
        val.delivered_at &&
        isFilledDeliveryAddress(val) &&
        products?.length > 0,
    );
  };

  const onProcessBulkUpload = async (id = '', file = null) => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      const url = await uploadS3({
        file: file || bulkProductFile,
        isNeedMobileSupport: true,
      });
      setBulkProductFile(null);
      if (url) {
        const payload = {
          uploded_from: 'order_menu',
          url,
        };

        if (isFromActivity && activityId) {
          payload.uploded_from = 'sales_activity_menu';
          payload.activity_id = activityId;
        }

        const salesOrderId = id || detailData?._id;
        await MsOrder.uploadBulkSalesOrderProduct(salesOrderId, payload);
        dispatch(
          showAlert({
            show: true,
            title: 'Information',
            description: 'Sales order product has been added',
            isConfirm: false,
            testID: 'sales-order-form-import-success',
            onCallback: () => {
              setIsReady(false);
              getDetail(salesOrderId);
            },
          }),
        );
      }
      dispatch(showPopup({ name: 'isLoading', value: false }));
      dispatch(
        showPopup({
          name: 'showImportModalSOProduct',
          value: false,
        }),
      );
    } catch (err) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      dispatch(
        showPopup({
          name: 'showImportModalSOProduct',
          value: false,
        }),
      );
    }
  };

  const onUploadBulkProduct = async (file) => {
    try {
      setBulkProductFile(file || {});
      if (detailData?._id) {
        onProcessBulkUpload(detailData?._id, file || {});
      } else {
        if (formRef.current) {
          formRef.current.handleSubmit();
        }
      }
    } catch (error) {
      console.error('error', error);
    }
  };

  const handleSetProducts = async ({ val, index }) => {
    if (detailData?._id) {
      setLoadingAddProduct(true);

      let isProductEdit = false;
      let prIndex = val.length - 1;
      if (index > -1) {
        prIndex = index;
        isProductEdit = true;
      }
      const newProduct = JSON.parse(JSON.stringify(val[prIndex]));
      try {
        if (!newProduct?.combination_id && newProduct?.combination?.id) {
          newProduct.combination_id = newProduct?.combination?.id;
        }
        delete newProduct.combination;
        delete newProduct.description;
        delete newProduct.how_to_use;
        delete newProduct.ingredients;
        delete newProduct.is_edit;
      } catch (error) {}
      try {
        if (isProductEdit && newProduct.is_qty_changed) {
          // Qty changed, remove GWP
          await handleCancelPromo(index);
        }

        const endpoint = isProductEdit
          ? 'updateProductSalesOrder'
          : 'createProductSalesOrder';
        const product_response = await MsOrder[endpoint](
          detailData?._id,
          newProduct,
        );
        if (product_response?.data?.data) {
          const res = product_response.data.data;
          val[prIndex] = res;
          if (res?.is_promo_available) {
            val[prIndex].is_promo_available = true;
          }
          if (res?.is_promo_reminder) {
            val[prIndex].is_promo_reminder = true;
          }
        }
      } catch (error) {
        const errorMessage =
          error?.response?.data?.message || 'A system error occurred';
        val.splice(index, 1);
        dispatch(
          showAlert({
            show: true,
            title: 'Error',
            description: errorMessage,
            isConfirm: false,
            testID: 'sales-order-form-add-product-error',
          }),
        );
      }
      await updateDetail(detailData._id);
      setLoadingAddProduct(false);
    } else {
      setProducts(val);
      if (formRef.current && val?.length == 1) {
        formRef.current.handleSubmit();
      }
    }
  };

  const handleCancelPromo = async (idx) => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    const oldData = JSON.parse(JSON.stringify(products));
    const productItem = JSON.parse(JSON.stringify(oldData[idx]));
    delete oldData[idx].free_product;
    delete oldData[idx].applied_promotion;
    if (productItem?.applied_promotion?.id) {
      try {
        await MsOrder.removePromoProductSalesOrder(
          detailData?._id,
          productItem?.applied_promotion?.id,
          productItem?.id,
          productItem?.combination?.id,
        );
      } catch (error) {}
    }
    await getProductSalesOrder(detailData?._id);
    dispatch(showPopup({ name: 'isLoading', value: false }));
  };

  const handleProductSelectPromo = async (
    promo,
    productIndex,
    isSelectProductGwp = false,
    selectedOption = 0,
  ) => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      const oldData = JSON.parse(JSON.stringify(products));
      const productItem = JSON.parse(JSON.stringify(oldData[productIndex]));

      const promoPayload = {
        ...productItem,
        combination_id: productItem?.combination?.id,
      };

      if (promo?.rules?.is_gwp_levelling) {
        // Validate promo first
        await MsOrder.validatePromotionRules(detailData?._id, promo.id, {
          combination_id: productItem?.combination?.id,
        });

        if (
          promo?.discount_info?.gwp_levelling_free_products?.length > 1 &&
          !isSelectProductGwp
        ) {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          setProductPromo(promo);
          setGwpProductOption(
            promo?.discount_info?.gwp_levelling_free_products,
          );
          setIndexGwpProduct(productIndex);
          return;
        }

        if (promo?.discount_info?.gwp_levelling_free_products?.length == 1) {
          // If we have only 1 option, automatically select it
          promoPayload.free_product_bundle_id =
            promo.discount_info.gwp_levelling_free_products[0]?.bundle_id;
        }

        if (isSelectProductGwp) {
          promoPayload.free_product_bundle_id =
            promo.discount_info?.gwp_levelling_free_products[
              selectedOption
            ]?.bundle_id;
        }
      }

      await MsOrder.createPromoProductSalesOrder(
        detailData?._id,
        promo.id,
        promoPayload,
      );
      await getProductSalesOrder(detailData?._id);
    } catch (err) {
      dispatch(
        showAlert({
          show: true,
          title: 'Error',
          description:
            err?.response?.data?.message || 'A system error occurred',
          isConfirm: false,
          testID: 'sales-order-form-promo-error',
        }),
      );
      const oldData = JSON.parse(JSON.stringify(products));
      const productItem = JSON.parse(JSON.stringify(oldData[productIndex]));
      delete oldData[productIndex].free_product;
      delete oldData[productIndex].applied_promotion;
      setProducts(oldData);
      try {
        if (productItem?.applied_promotion?.id) {
          await MsOrder.removePromoProductSalesOrder(
            detailData?._id,
            productItem?.applied_promotion?.id,
            productItem?.id,
            productItem?.combination?.id,
          );
        }
      } catch (error) {}
    }
    dispatch(showPopup({ name: 'isLoading', value: false }));
  };

  const titlePage = isSpreading
    ? isEdit
      ? 'Edit Sales Order Spreading'
      : 'Add Sales Order Spreading'
    : isEdit
    ? 'Edit Sales Order'
    : 'Add Sales Order';

  const isLoadingPage =
    (isEdit
      ? getSalesOrderDetail.loading ||
        !(detailData && Object.keys(detailData).keys.length)
      : true) && !isReady;

  const isEmpty = (value) => {
    return (
      value === undefined ||
      value === null ||
      (typeof value === 'string' && value.trim() === '') ||
      (typeof value === 'object' && Object.keys(value).length === 0)
    );
  };

  return (
    <Layout.Container testID="sales-order-form-screen">
      {!isWeb && (
        <ProgressBar
          testID="sales-order-form-progress-bar"
          page={page}
          totalPage={totalPage}
        />
      )}
      {isLoadingPage ? (
        <Layout.Wrapper rounded>
          <Layout.Loader />
        </Layout.Wrapper>
      ) : (
        <Formik
          innerRef={formRef}
          initialValues={{
            customer:
              isEdit &&
              detailData?.customer &&
              Object.keys(detailData.customer).length
                ? detailData.customer
                : '',
            invoice_address:
              isEdit &&
              detailData?.invoice_address &&
              Object.keys(detailData.invoice_address).length
                ? detailData.invoice_address
                : {},
            delivery_address: taskDeliveryAddress
              ? taskDeliveryAddress?.address
              : isEdit &&
                detailData?.delivery_address &&
                Object.keys(detailData.delivery_address).length
              ? detailData.delivery_address
              : {},
            sales_person:
              isEdit && detailData?.user && Object.keys(detailData.user).length
                ? detailData.user
                : '',
            sales_team: isEdit
              ? detailData?.user && Object.keys(detailData.user).length
                ? {
                    id: detailData.user.team_id,
                    name: detailData.user.team_name,
                    pacman_warehouse_id: detailData.user.pacman_warehouse_id,
                  }
                : ''
              : '',
            expiration_date:
              isEdit &&
              detailData?.expiration_date &&
              Object.keys(detailData.expiration_date).length
                ? detailData.expiration_date
                : '',
            pricelist:
              isEdit && detailData?.price_list?.id
                ? {
                    id: detailData.price_list.id,
                    name: detailData.price_list.name,
                    taxes_type: detailData.price_list.taxes_type,
                  }
                : '',
            customer_po_number:
              isEdit && detailData?.customer_po_number
                ? detailData.customer_po_number
                : '',
            customer_po_date:
              isEdit && detailData?.customer_po_date
                ? new Date(detailData.customer_po_date)
                : '',
            delivered_at:
              isEdit && detailData?.delivered_at
                ? new Date(detailData.delivered_at)
                : '',
            regular_discount:
              isEdit && detailData?.regular_discount?.id
                ? detailData.regular_discount
                : '',
            cash_before_delivery:
              isEdit && detailData?.cash_before_delivery?.id
                ? detailData.cash_before_delivery
                : '',

            warehouse: isEdit
              ? detailData?.user && Object.keys(detailData.user).length
                ? {
                    id: detailData.user.team_warehouse?.id,
                    name: detailData.user.team_warehouse?.name,
                    pacman_warehouse_id:
                      detailData.user.team_warehouse?.pacman_warehouse_id,
                  }
                : ''
              : '',
            status: isEdit && detailData?.status ? detailData.status : 'draft',
            attachment:
              isEdit && detailData?.attachments?.length
                ? detailData.attachments
                : [],
            is_clearance: isEdit && detailData?.is_clearance ? true : false,
            notes: isEdit && detailData?.notes ? detailData.notes : '',
            payment_proof:
              isEdit && detailData?.payment_proof
                ? detailData.payment_proof
                : '',
            type:
              isEdit && detailData?.type
                ? detailData.type
                : isSpreading
                ? 'spreading'
                : 'direct',
          }}
          validationSchema={FormValidationSchema}
          onSubmit={async (values) => {
            const fields = {
              sales_team: 'Sales Team',
              warehouse: 'Warehouse',
              sales_person: 'Sales Person',
            };

            const emptyFields = Object.entries(fields)
              .filter(([key]) => isEmpty(values[key]))
              .map(([, label]) => label);

            if (emptyFields.length > 0) {
              Toast.show({
                text1: `Empty fields: ${emptyFields.join(', ')}`,
                type: 'error',
              });
            } else {
              setIsSubmit(true);
              dispatch(showPopup({ name: 'isLoading', value: true }));
              // check already have customer po number or not
              let isPONumberExist = false;
              if (values.customer_po_number) {
                const customerFilter = {
                  customer_po_number: values.customer_po_number,
                };
                if (isEdit) {
                  customerFilter._id = { $ne: detailData?._id };
                }
                const checkPONumber = await getSalesOrderCount.request({
                  params: { filter: customerFilter },
                });
                if (checkPONumber?.data?.data) {
                  isPONumberExist = true;
                }
              }
              if (isPONumberExist) {
                setIsSubmit(false);
                dispatch(showPopup({ name: 'isLoading', value: false }));
                Toast.show({
                  text1: 'Customer PO number is already used.',
                  type: 'error',
                });
              } else {
                const alert_description = ['draft', 'quotation'].includes(
                  values.status,
                )
                  ? `Sales order saved as a ${
                      isQuotation ? 'quotation' : 'draft'
                    }`
                  : 'Sales order submitted and need confirmation';
                const payload = {
                  status: values.status,
                  customer: {
                    id: values.customer?.id ? values.customer.id : '',
                    name: values.customer?.name ? values.customer.name : '',
                  },
                  user:
                    values.sales_person &&
                    Object.keys(values.sales_person).length
                      ? {
                          id: values.sales_person.id,
                          name: values.sales_person.name,
                          branch_code: ['superadmin', 'general'].includes(
                            userRole,
                          )
                            ? 'HO'
                            : branchCode || '',
                          team_id: values?.sales_team?.id
                            ? values.sales_team.id
                            : '',
                          team_name: values?.sales_team?.name
                            ? values.sales_team.name
                            : '',
                          team_warehouse: values.warehouse?.id
                            ? values.warehouse
                            : '',
                        }
                      : '',
                  invoice_address: values.invoice_address,
                  delivery_address: values.delivery_address,
                  customer_po_number: values.customer_po_number,
                  invoice_status: values.invoice_status || 'nothing_to_invoice',
                  subtotal: subTotal,
                  total_tax_amount: taxes,
                  total_amount: total,
                  order_date: new Date().toISOString(),
                  is_clearance: values.is_clearance || false,
                  notes: values.notes || '',
                  is_spreading: isSpreading,
                  payment_proof: values.payment_proof || '',
                  type: values.type || 'direct',
                };
                if (!isEdit) {
                  payload.attachments = values?.attachment?.length
                    ? values.attachment
                    : [];
                }
                if (!isEdit && products?.length == 1) {
                  const added_product = JSON.parse(JSON.stringify(products[0]));
                  try {
                    delete added_product.combination;
                    delete added_product.description;
                    delete added_product.how_to_use;
                    delete added_product.ingredients;
                  } catch (error) {}
                  payload.product = added_product;
                }
                if (values.pricelist && Object.keys(values.pricelist).length) {
                  payload.price_list = {
                    id: values.pricelist.id,
                    name: values.pricelist.name,
                    taxes_type: values.pricelist.taxes_type,
                  };
                }
                if (values.expiration_date) {
                  payload.expiration_date = new Date(
                    values.expiration_date,
                  ).toISOString();
                }
                if (values.customer_po_date) {
                  payload.customer_po_date = new Date(
                    values.customer_po_date,
                  ).toISOString();
                }
                if (values.delivered_at) {
                  payload.delivered_at = new Date(
                    values.delivered_at,
                  ).toISOString();
                }
                if (values.regular_discount?.id) {
                  payload.regular_discount = {
                    id: values.regular_discount.id,
                    name: values.regular_discount.name,
                  };
                }
                if (values.cash_before_delivery?.id) {
                  payload.cash_before_delivery = {
                    id: values.cash_before_delivery.id,
                    name: values.cash_before_delivery.name,
                    percentage: values.cash_before_delivery?.discount_info
                      ? values.cash_before_delivery.discount_info
                          .deduction_percentage
                      : values.cash_before_delivery.percentage,
                  };
                }
                if (values.invoice_address?._id) {
                  payload.invoice_address.id = values.invoice_address._id;
                }
                if (values.delivery_address?._id) {
                  payload.delivery_address.id = values.delivery_address._id;
                }
                if (activityId && taskId) {
                  payload.activity = {
                    id: activityId,
                    task_id: taskId,
                  };
                }
                try {
                  if (isEdit) {
                    // Check is order spreading
                    if (
                      detailData.type == 'spreading' &&
                      values.status == 'need_approval' &&
                      payload.attachments.length == 0
                    ) {
                      dispatch(showPopup({ name: 'isLoading', value: false }));
                      Toast.show({
                        text1: 'Attachment is required',
                        type: 'error',
                      });
                      return;
                    }

                    const updateData = await MsOrder.updateSalesOrder(
                      detailData._id,
                      payload,
                    );
                    if (updateData && updateData.data && updateData.data.data) {
                      setCustomerChanged(false);
                      dispatch(showPopup({ name: 'isLoading', value: false }));
                      dispatch(
                        showAlert({
                          show: true,
                          title: 'Sales Order Submitted',
                          description: alert_description,
                          isConfirm: false,
                          testID: 'sales-order-form-submitted',
                          onCallback: () => {
                            global.isFromAdded = true;
                            if (isEdit) {
                              props.navigation.navigate(
                                'SalesOrderDetailScreen',
                                props.route.params,
                              );
                            } else {
                              props.navigation.navigate('SalesOrderScreen', {
                                titleScreen: detailData.reference_code,
                                name: detailData.name,
                                id: detailData._id,
                                ...(activityId && taskId
                                  ? {
                                      activityId: activityId,
                                      taskId: taskId,
                                    }
                                  : {}),
                              });
                            }
                          },
                        }),
                      );
                    } else {
                      setIsSubmit(false);
                      dispatch(showPopup({ name: 'isLoading', value: false }));
                      Toast.show({
                        text1: 'A system error occurred',
                        type: 'error',
                      });
                    }
                  } else {
                    logEvent({
                      eventName: isSpreading
                        ? 'create_sales_order_spreading'
                        : 'create_sales_order',
                      data: payload,
                      dataKey: 'detail',
                    });
                    const createData = await MsOrder.createSalesOrder(payload);
                    if (createData && createData.data && createData.data.data) {
                      const result = createData.data.data;
                      dispatch(showPopup({ name: 'isLoading', value: false }));
                      if (
                        !isEdit &&
                        (products?.length == 1 || bulkProductFile)
                      ) {
                        if (result._id) {
                          global.isFromAdded = true;
                          onProcessBulkUpload(result._id);
                          props.navigation.navigate('SalesOrderFormScreen', {
                            titleScreen: result.reference_code,
                            name: result.customer.name,
                            id: result._id,
                            firstAdded: true,
                            ...(activityId && taskId
                              ? {
                                  activityId: activityId,
                                  taskId: taskId,
                                }
                              : {}),
                          });
                        }
                      } else {
                        dispatch(
                          showAlert({
                            show: true,
                            title: 'Sales Order Submitted',
                            description: alert_description,
                            hideCancel: true,
                            testID: 'sales-order-form-submitted',
                            onCallback: () => {
                              global.isFromAdded = true;
                              if (result._id) {
                                props.navigation.navigate(
                                  'SalesOrderDetailScreen',
                                  {
                                    titleScreen: result.reference_code,
                                    name: result.name,
                                    id: result._id,
                                    ...(activityId && taskId
                                      ? {
                                          activityId: activityId,
                                          taskId: taskId,
                                        }
                                      : {}),
                                  },
                                );
                              } else {
                                props.navigation.navigate('SalesOrderScreen');
                              }
                            },
                          }),
                        );
                      }
                    } else {
                      setIsSubmit(false);
                      dispatch(showPopup({ name: 'isLoading', value: false }));
                      Toast.show({
                        text1: 'A system error occurred',
                        type: 'error',
                      });
                    }
                  }
                } catch (error) {
                  setIsSubmit(false);
                  if (!isEdit && products?.length == 1) {
                    setProducts([]);
                  }
                  dispatch(showPopup({ name: 'isLoading', value: false }));
                  const errorMessage =
                    error?.response?.data?.message || 'A system error occurred';
                  if (
                    error?.response?.data?.errorCode == 'BAD_REQUEST' &&
                    error?.response?.data?.message &&
                    error?.response?.data?.message.indexOf('overlimit') > -1 &&
                    formRef.current
                  ) {
                    formRef.current.setErrors({
                      customer: error.response.data.message,
                    });
                    if (!isWeb) {
                      // Toast.show({
                      //   text1: error?.response?.data?.message,
                      //   type: 'error',
                      // });
                      dispatch(
                        showAlert({
                          show: true,
                          title: 'Error',
                          description: errorMessage,
                          isConfirm: false,
                          testID: 'sales-order-form-submit-error',
                        }),
                      );
                      setPage(1);
                    }
                  } else {
                    // Toast.show({
                    //   text1:
                    //     error?.response?.data?.message ||
                    //     'A system error occurred',
                    //   type: 'error',
                    // });
                    dispatch(
                      showAlert({
                        show: true,
                        title: 'Error',
                        description: errorMessage,
                        isConfirm: false,
                        testID: 'sales-order-form-submit-error',
                      }),
                    );
                  }
                }
              }
            }
          }}>
          {({
            handleChange,
            setFieldValue,
            validateForm,
            handleSubmit,
            errors,
            touched,
            values,
          }) => (
            <>
              {isWeb ? (
                <Layout.Wrapper white={false}>
                  <Layout.Back
                    title={
                      activityId && taskId
                        ? 'Order Activity'
                        : isEdit
                        ? props.route.params.name
                        : 'Sales Order'
                    }
                    onCallback={() => needToBack()}
                  />
                  <Layout.Title title={titlePage}>
                    {isEdit ? (
                      <Button
                        testID="sales-order-form-save-btn"
                        rounded
                        buttonStyle={{ width: 120 }}
                        disabledStyle={{ width: 120 }}
                        disabled={!isAvailableEdit}
                        title={
                          <SociollaText
                            type="bold"
                            style={{
                              fontSize: 14,
                              letterSpacing: 0.5,
                              color: Colors.white,
                            }}>
                            {isAvailableEdit ? 'SAVE' : 'LOADING'}
                          </SociollaText>
                        }
                        onPress={(evt) => {
                          evt.persist();
                          setTimeout(() => {
                            validateForm().then((validate) => {
                              handleSubmit(evt);
                              if (validate && Object.keys(validate).length) {
                                setPage(1);
                              }
                            });
                          }, 100);
                        }}
                      />
                    ) : (
                      <View
                        style={{
                          width: 300,
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'flex-end',
                        }}>
                        <Button
                          testID="sales-order-form-save-draft-btn"
                          type="primary"
                          rounded
                          buttonStyle={{ width: 105, marginRight: 10 }}
                          title={
                            <SociollaText
                              type="bold"
                              style={{
                                fontSize: 14,
                                letterSpacing: 0.5,
                                color: Colors.white,
                              }}>
                              Save Draft
                            </SociollaText>
                          }
                          onPress={(evt) => {
                            evt.persist();
                            setFieldValue('status', 'draft');
                            setTimeout(() => {
                              validateForm().then((validate) => {
                                handleSubmit(evt);
                                if (validate && Object.keys(validate).length) {
                                  setPage(1);
                                }
                              });
                            }, 100);
                          }}
                        />
                        <Button
                          testID="sales-order-form-request-confirmation-btn"
                          rounded
                          buttonStyle={{ width: 185 }}
                          disabledStyle={{ width: 185 }}
                          disabled={!isAvailableSubmit(values)}
                          title={
                            <SociollaText
                              type="bold"
                              style={{
                                fontSize: 14,
                                letterSpacing: 0.5,
                                color: Colors.white,
                              }}>
                              Request Confirmation
                            </SociollaText>
                          }
                          onPress={(evt) => {
                            evt.persist();
                            if (!isEdit) {
                              onChangeFilter();
                            }
                            setFieldValue('status', 'need_approval');
                            setTimeout(() => {
                              validateForm().then((validate) => {
                                handleSubmit(evt);
                                if (validate && Object.keys(validate).length) {
                                  setPage(1);
                                }
                              });
                            }, 100);
                          }}
                        />
                      </View>
                    )}
                  </Layout.Title>
                </Layout.Wrapper>
              ) : (
                false
              )}
              <Layout.Wrapper rounded hasProgressBar>
                <ScrollView
                  // One ScrollView wraps both wizard pages, so it would otherwise
                  // keep the offset the user left on the previous step. Keying on
                  // page gives each step a fresh ScrollView at offset 0.
                  key={`sales-order-form-page-${page}`}
                  style={isMobileWeb ? { height: dimension.height - 55 } : {}}
                  contentContainerStyle={{ width: '100%' }}>
                  {page == 1 || isWeb ? (
                    <Layout.FormWrapper
                      style={{
                        paddingHorizontal: isWeb ? 20 : 15,
                        ...(isWeb
                          ? { paddingVertical: 20 }
                          : {
                              paddingBottom: !isMobileWeb
                                ? isAndroid
                                  ? 150
                                  : 80
                                : 100,
                            }),
                      }}>
                      <View
                        style={{
                          width: isWeb ? 'calc(50% - 30px)' : '100%',
                          marginRight: isWeb ? 30 : 0,
                        }}>
                        <Layout.FormGroup>
                          <CustomerSearch
                            fields="_id name market_type sales_team user cluster special_discount customer_type invoice_address delivery_address"
                            value={values.customer}
                            isRequired={true}
                            hasError={
                              errors.customer && touched.customer
                                ? errors.customer
                                : null
                            }
                            customFilter={{
                              status: 'approved',
                              cerebro_id: { $exists: true },
                              is_active: true,
                              ...(isSpreading
                                ? {
                                    'market_type.business_type.cerebro_id': {
                                      $in: BUSINESS_TYPE_SPREADING,
                                    },
                                  }
                                : {}),
                            }}
                            editable={
                              !props?.route?.params?.customerActivityId &&
                              !isQuotation
                            }
                            onChange={async (value) => {
                              setBranchCode('');
                              setSelectedSalesTeam({});
                              setFieldValue('sales_person', {});
                              setFieldValue('sales_team', {});
                              setFieldValue('invoice_address', {});
                              setFieldValue('delivery_address', {});
                              setFieldValue('pricelist', {});
                              setFieldValue('warehouse', {});
                              setFieldValue('regular_discount', '');
                              if (value?.id) {
                                setSelectedCustomer({
                                  id: value.id,
                                  name: value.name,
                                  market_type: value.market_type,
                                  special_discount: value.special_discount || 0,
                                  cluster: value.cluster,
                                  customer_type: value.customer_type || '',
                                });
                                getCustomerCluster(value.id);
                                if (!isSpreading) {
                                  if (
                                    value?.market_type?.code?.toLowerCase() ==
                                    'gt'
                                  ) {
                                    getCustomerPoNumber(value.id);
                                  } else {
                                    setIsDisabledPoNumber(false);
                                    setFieldValue('customer_po_number', '');
                                  }
                                }
                              }
                              setFieldValue('customer', value);
                              if (orderId) {
                                setCustomerChanged(true);
                              }
                              if (products?.length) {
                                setProducts([]);
                              }
                              if (value) {
                                if (
                                  value?.market_type?.code?.toLowerCase() ==
                                  'mt'
                                ) {
                                  // auto fill sales team based on customer sales team
                                  if (userSalesTeam?.length) {
                                    const selectedST = userSalesTeam[0];
                                    if (selectedST?.id) {
                                      setSelectedSalesTeam(selectedST);
                                      setFieldValue('warehouse', userWarehouse);
                                    }
                                    setFieldValue('sales_team', selectedST);
                                  } else {
                                    setSelectedSalesTeam({});
                                    setFieldValue('sales_team', {});
                                  }
                                  if (value.user?.branch_code) {
                                    setBranchCode(value.user.branch_code);
                                  }
                                } else {
                                  // auto fill sales person and branch code based on customer user
                                  if (
                                    value.user &&
                                    Object.keys(value.user).length
                                  ) {
                                    if (value.user.branch_code) {
                                      setBranchCode(value.user.branch_code);
                                    }
                                    setFieldValue('sales_person', value.user);
                                  } else {
                                    setFieldValue('sales_person', {});
                                  }

                                  // auto fill sales team based on customer sales team
                                  if (
                                    value.sales_team &&
                                    Object.keys(value.sales_team).length
                                  ) {
                                    if (value.sales_team?.id) {
                                      setSelectedSalesTeam(value.sales_team);
                                      setFieldValue(
                                        'warehouse',
                                        value.sales_team.warehouse,
                                      );
                                    }
                                    setFieldValue(
                                      'sales_team',
                                      value.sales_team,
                                    );
                                  } else {
                                    setBranchCode('');
                                    setSelectedSalesTeam({});
                                    setFieldValue('sales_team', {});
                                  }
                                }
                                // get customer invoice address and make it auto fill when customer have one address only
                                if (
                                  value.invoice_address &&
                                  value.invoice_address.length
                                ) {
                                  const invoices = value.invoice_address.map(
                                    (item) => {
                                      if (item._id) {
                                        item.id = item._id;
                                      }
                                      return item;
                                    },
                                  );
                                  if (invoices.length == 1) {
                                    setFieldValue(
                                      'invoice_address',
                                      invoices[0],
                                    );
                                  } else {
                                    setFieldValue('invoice_address', {});
                                  }
                                  setInvoiceAddress(invoices);
                                } else {
                                  setFieldValue('invoice_address', {});
                                }
                                // get customer delivery address and make it auto fill when customer have one address only
                                if (
                                  value.delivery_address &&
                                  value.delivery_address.length
                                ) {
                                  const delivery = value.delivery_address.map(
                                    (item) => {
                                      if (item._id) {
                                        item.id = item._id;
                                      }
                                      return item;
                                    },
                                  );
                                  if (delivery.length == 1) {
                                    setFieldValue(
                                      'delivery_address',
                                      delivery[0],
                                    );
                                    setIsConsignment(
                                      !!delivery[0].is_consignment,
                                    );
                                  } else {
                                    setFieldValue('delivery_address', {});
                                    setIsConsignment(false);
                                  }

                                  // TODO: Filter by order type on Consignment Phase 2
                                  setDeliveryAddress(delivery);
                                } else {
                                  setFieldValue('delivery_address', {});
                                  setIsConsignment(false);
                                }
                              } else {
                                setBranchCode('');
                                setSelectedSalesTeam({});
                                setFieldValue('sales_person', {});
                                setFieldValue('sales_team', {});
                                setFieldValue('invoice_address', {});
                                setFieldValue('delivery_address', {});
                                setIsConsignment(false);
                              }
                              setIsLoadingCustomer(true);
                              setTimeout(() => {
                                setIsLoadingCustomer(false);
                              }, 250);
                            }}
                          />
                        </Layout.FormGroup>
                        <Layout.FormGroup>
                          <SelectBox
                            label="Invoice Address"
                            options={invoiceAddress}
                            value={values.invoice_address}
                            placeholder="Select Invoice Address"
                            trackBy="_id"
                            labelKey="name"
                            isRequired={true}
                            hasError={
                              errors.invoice_address && touched.invoice_address
                                ? errors.invoice_address
                                : null
                            }
                            onChange={(value) =>
                              setFieldValue('invoice_address', value)
                            }
                            editable={!isQuotation}
                          />
                        </Layout.FormGroup>
                        <Layout.FormGroup
                          style={{
                            width: '100%',
                            flexDirection: 'row',
                            marginTop: 5,
                          }}>
                          <View style={{ width: '30%' }}>
                            <SociollaText
                              style={{
                                fontSize: 11,
                                color: '#303030',
                                lineHeight: 18,
                              }}>
                              Address
                            </SociollaText>
                          </View>
                          <View style={{ width: '70%' }}>
                            <SociollaText
                              style={{
                                fontSize: 12,
                                color: '#303030',
                                lineHeight: 18,
                              }}>
                              {values.invoice_address &&
                              Object.keys(values.invoice_address).length
                                ? convertFullAddress(values.invoice_address)
                                : '-'}
                              {/* Jl. Cut Mutia No 1 Kel. Madras Hulu, Kec Medan Polonia Meda Sumatra Utara (ID) 20212 Indonesia */}
                            </SociollaText>
                          </View>
                        </Layout.FormGroup>
                        <Layout.FormGroup>
                          <SelectBox
                            label="Delivery Address"
                            options={deliveryAddress}
                            value={values.delivery_address}
                            placeholder="Select Delivery Address"
                            trackBy="_id"
                            labelKey="name"
                            isRequired={true}
                            hasError={
                              errors.delivery_address &&
                              touched.delivery_address
                                ? errors.delivery_address
                                : null
                            }
                            onChange={(value) => {
                              setFieldValue('delivery_address', value);
                              setIsConsignment(!!value.is_consignment);
                            }}
                            editable={!isQuotation}
                          />
                        </Layout.FormGroup>
                        <Layout.FormGroup
                          style={{
                            width: '100%',
                            flexDirection: 'row',
                            marginTop: 5,
                          }}>
                          <View style={{ width: '30%' }}>
                            <SociollaText
                              style={{
                                fontSize: 11,
                                color: '#303030',
                                lineHeight: 18,
                              }}>
                              Address
                            </SociollaText>
                          </View>
                          <View style={{ width: '70%' }}>
                            <SociollaText
                              style={{
                                fontSize: 12,
                                color: '#303030',
                                lineHeight: 18,
                              }}>
                              {values.delivery_address &&
                              Object.keys(values.delivery_address).length
                                ? convertFullAddress(values.delivery_address)
                                : '-'}
                              {/* Jl. Cut Mutia No 1 Kel. Madras Hulu, Kec Medan Polonia Meda Sumatra Utara (ID) 20212 Indonesia */}
                            </SociollaText>
                          </View>
                        </Layout.FormGroup>
                        <Layout.FormGroup>
                          {selectedCustomer?.market_type?.code?.toLowerCase() ==
                          'mt' ? (
                            <SalesTeamSearch
                              isRequired
                              value={
                                values.sales_team && values.sales_team.id
                                  ? values.sales_team
                                  : ''
                              }
                              hasError={
                                errors.sales_team && touched.sales_team
                                  ? errors.sales_team
                                  : null
                              }
                              customFilter={
                                userSalesTeam?.length
                                  ? {
                                      _id: {
                                        $in: userSalesTeam.map((st) => st.id),
                                      },
                                    }
                                  : {}
                              }
                              onChange={(value) => {
                                setSelectedSalesTeam(value);
                                setFieldValue('sales_team', value);
                                setFieldValue('warehouse', value.warehouse);
                                setFieldValue('sales_person', {});
                              }}
                            />
                          ) : (
                            <Input
                              label="Sales Team"
                              value={
                                values.sales_team && values.sales_team.id
                                  ? values.sales_team.name
                                  : ''
                              }
                              isRequired
                              editable={false}
                              hasError={
                                errors.sales_team && touched.sales_team
                                  ? errors.sales_team
                                  : null
                              }
                            />
                          )}
                        </Layout.FormGroup>
                        <Layout.FormGroup>
                          {selectedCustomer?.market_type?.code?.toLowerCase() ==
                          'mt' ? (
                            <SalesPersonSearch
                              isRequired
                              label="Sales Person"
                              value={
                                values.sales_person && values.sales_person.id
                                  ? values.sales_person.name
                                  : ''
                              }
                              customFilter={{
                                remove_default_filter: true,
                                $or: [
                                  {
                                    'role.code': {
                                      $in: [
                                        'branch_head',
                                        'sales_supervisor',
                                        'sales_admin',
                                        'salesman',
                                        'finance_supervisor',
                                      ],
                                    },
                                  },
                                  {
                                    $and: [
                                      { 'role.code': 'salesman' },
                                      { sales_code: { $exists: true } },
                                    ],
                                  },
                                ],
                                sales_team: {
                                  $elemMatch: { id: values.sales_team.id },
                                },
                              }}
                              hasError={
                                errors.sales_person && touched.sales_person
                                  ? errors.sales_person
                                  : null
                              }
                              onChange={(value) => {
                                setFieldValue('sales_person', value);
                              }}
                            />
                          ) : (
                            <Input
                              label="Sales Person"
                              value={
                                values.sales_person && values.sales_person.id
                                  ? values.sales_person.name
                                  : ''
                              }
                              isRequired
                              hasError={
                                errors.sales_person && touched.sales_person
                                  ? errors.sales_person
                                  : null
                              }
                            />
                          )}
                        </Layout.FormGroup>

                        {/* Warehouse */}
                        <Layout.FormGroup>
                          <WarehouseSearch
                            label="Warehouse"
                            value={values.warehouse}
                            idSales={selectedSalesTeam}
                            hasError={
                              errors.warehouse && touched.warehouse
                                ? errors.warehouse
                                : null
                            }
                            editable={selectedSalesTeam?.id ? true : false}
                            isRequired={true}
                            onChange={(value) => {
                              setFieldValue('warehouse', value);
                            }}
                            useCallbackOptions={[selectedSalesTeam]}
                          />
                        </Layout.FormGroup>
                        <Layout.FormGroup>
                          <SelectBox
                            label="Order Type"
                            options={orderTypeOptions}
                            value={values.type}
                            placeholder="Select Order Type"
                            trackBy="value"
                            labelKey="label"
                            isRequired={true}
                            hasError={
                              errors.type && touched.type ? errors.type : null
                            }
                            onChange={(value) =>
                              setFieldValue('type', value.value)
                            }
                            editable={
                              !isQuotation &&
                              !isSpreading &&
                              values.type != 'consignment_report'
                            }
                          />
                        </Layout.FormGroup>
                        {!isSpreading ? (
                          <Layout.FormGroup
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              gap: 20,
                              marginTop: 10,
                            }}>
                            <SociollaText>Clearance</SociollaText>
                            <SociollaCheckbox label="" name="is_clearance" />
                          </Layout.FormGroup>
                        ) : (
                          false
                        )}
                      </View>
                      <View
                        style={{
                          width: isWeb ? 'calc(50% - 30px)' : '100%',
                          marginRight: isWeb ? 30 : 0,
                        }}>
                        <Layout.FormGroup>
                          <DatePicker
                            testID="sales-order-form-expiration-date"
                            label="Expiration Date"
                            name="expiration_date"
                            disablePastDates={true}
                            value={values.expiration_date}
                            disableBeforeDate={
                              new Date(values.delivered_at) >
                              new Date(values.customer_po_date)
                                ? values.delivered_at
                                : values.customer_po_date
                            }
                            isRequired={true}
                            hasError={
                              errors.expiration_date && touched.expiration_date
                                ? errors.expiration_date
                                : null
                            }
                            onChange={(value) =>
                              setFieldValue(
                                'expiration_date',
                                new Date(value).toDateString(),
                              )
                            }
                            disabled={isQuotation}
                          />
                        </Layout.FormGroup>
                        <Layout.FormGroup>
                          <PriceRulesSearch
                            value={values.pricelist}
                            isRequired={true}
                            customFilter={{
                              is_enable: true,
                              order_type: isConsignment
                                ? 'consignment_report'
                                : 'direct',
                              ...(selectedCustomer?.market_type?.id
                                ? {
                                    'market_type.id':
                                      selectedCustomer.market_type.id,
                                  }
                                : { empty: true }),
                            }}
                            hasError={
                              errors.pricelist && touched.pricelist
                                ? errors.pricelist
                                : null
                            }
                            loading={isLoadingCustomer}
                            useCallbackOptions={[
                              selectedCustomer?.market_type?.id,
                            ]}
                            onChange={async (value) => {
                              const oldPriceRules = JSON.parse(
                                JSON.stringify(values.pricelist),
                              );
                              if (oldPriceRules?.id) {
                                if (
                                  oldPriceRules?.id != value.id &&
                                  products?.length &&
                                  !isQuotation
                                ) {
                                  setPriceRulesChange(true);
                                  dispatch(
                                    showAlert({
                                      show: true,
                                      title: 'Alert',
                                      description:
                                        'All products you have added will be lost, are you sure?',
                                      testID:
                                        'sales-order-form-pricelist-change',
                                      onCallbackCancel: () => {
                                        setPriceRulesId(oldPriceRules?.id);
                                        setFieldValue(
                                          'pricelist',
                                          oldPriceRules,
                                        );
                                      },
                                      onCallback: async () => {
                                        setRulesTaxTypes(value?.taxes_type);
                                        setPriceRulesId(value.id);
                                        setFieldValue('pricelist', value);
                                        if (products?.length) {
                                          setSubTotal(0);
                                          setTaxes(0);
                                          setTotal(0);
                                          setProducts([]);
                                        }
                                        if (isEdit) {
                                          await MsOrder.updatePriceRulesOrder(
                                            detailData?._id,
                                            oldPriceRules?.id,
                                            {
                                              price_list_id: value.id,
                                            },
                                          );
                                        }
                                      },
                                    }),
                                  );
                                } else {
                                  setPriceRulesId(value.id);
                                  setFieldValue('pricelist', value);
                                  setRulesTaxTypes(value?.taxes_type);
                                  if (isEdit) {
                                    await MsOrder.updatePriceRulesOrder(
                                      detailData?._id,
                                      oldPriceRules?.id,
                                      { price_list_id: value.id },
                                    );
                                  }
                                }
                              } else {
                                setPriceRulesId(value.id);
                                setFieldValue('pricelist', value);
                                setRulesTaxTypes(value?.taxes_type);
                              }
                            }}
                          />
                        </Layout.FormGroup>
                        <Layout.FormGroup>
                          <Input
                            label="Customer PO Number"
                            value={values.customer_po_number}
                            isRequired={true}
                            hasError={
                              errors.customer_po_number &&
                              touched.customer_po_number
                                ? errors.customer_po_number
                                : null
                            }
                            disabled={isDisabledPoNumber || isQuotation}
                            onChangeText={
                              !isDisabledPoNumber
                                ? handleChange('customer_po_number')
                                : false
                            }
                          />
                        </Layout.FormGroup>
                        <Layout.FormGroup>
                          <DatePicker
                            testID="sales-order-form-customer-po-date"
                            label="Customer PO Date"
                            name="customer_po_date"
                            value={values.customer_po_date}
                            // disablePastDates={true}
                            disableBeforeDate={
                              new Date(
                                new Date().setMonth(new Date().getMonth() - 1),
                              )
                            }
                            isRequired={true}
                            hasError={
                              errors.customer_po_date &&
                              touched.customer_po_date
                                ? errors.customer_po_date
                                : null
                            }
                            onChange={(value) => {
                              const newDate = new Date(value);
                              if (newDate > new Date(values.expiration_date)) {
                                setFieldValue(
                                  'expiration_date',
                                  new Date(
                                    newDate.getFullYear(),
                                    newDate.getMonth(),
                                    newDate.getDate() + 2,
                                  ).toDateString(),
                                );
                              }
                              if (
                                newDate > new Date(values.delivered_at) ||
                                !values.delivered_at
                              ) {
                                setFieldValue(
                                  'delivered_at',
                                  new Date(
                                    newDate.getFullYear(),
                                    newDate.getMonth(),
                                    newDate.getDate() + 1,
                                  ).toDateString(),
                                );
                              }
                              setFieldValue(
                                'customer_po_date',
                                newDate.toDateString(),
                              );
                            }}
                            disabled={isQuotation}
                          />
                        </Layout.FormGroup>
                        <Layout.FormGroup>
                          <DatePicker
                            testID="sales-order-form-delivery-date"
                            label="Delivery Date (Expected)"
                            name="delivered_at"
                            value={values.delivered_at}
                            disablePastDates={true}
                            isRequired={true}
                            hasError={
                              errors.delivered_at && touched.delivered_at
                                ? errors.delivered_at
                                : null
                            }
                            onChange={(value) => {
                              const newDate = new Date(value);
                              if (newDate < new Date(values.customer_po_date)) {
                                setFieldValue(
                                  'customer_po_date',
                                  new Date(
                                    newDate.getFullYear(),
                                    newDate.getMonth(),
                                    newDate.getDate() - 1,
                                  ).toDateString(),
                                );
                              }
                              if (newDate > new Date(values.expiration_date)) {
                                setFieldValue(
                                  'expiration_date',
                                  new Date(
                                    newDate.getFullYear(),
                                    newDate.getMonth(),
                                    newDate.getDate() + 2,
                                  ).toDateString(),
                                );
                              }
                              setFieldValue(
                                'delivered_at',
                                newDate.toDateString(),
                              );
                            }}
                          />
                        </Layout.FormGroup>
                        <Layout.FormGroup>
                          {isLoadingCluster ? (
                            <InputLoading label="Regular Discount" />
                          ) : (
                            <Input
                              label="Regular Discount"
                              value={values.regular_discount?.name || ''}
                              editable={false}
                            />
                          )}
                        </Layout.FormGroup>
                        <Layout.FormGroup>
                          <PromotionRulesSearch
                            label="Cash Before Delivery"
                            promoType="cash_before_delivery"
                            value={values.cash_before_delivery}
                            formLabelKey={
                              values.cash_before_delivery?.discount_info
                                ? 'discount_info.deduction_percentage'
                                : 'percentage'
                            }
                            editable={!products?.length}
                            hasError={
                              errors.cash_before_delivery &&
                              touched.cash_before_delivery
                                ? errors.cash_before_delivery
                                : null
                            }
                            withReset
                            onChange={(value) => {
                              setSelectedCashBeforeDelivery(value);
                              setFieldValue('cash_before_delivery', value);
                            }}
                          />
                        </Layout.FormGroup>
                        <Layout.FormGroup>
                          <Input
                            label="Notes"
                            value={values.notes}
                            hasError={
                              errors.notes && touched.notes
                                ? errors.notes
                                : null
                            }
                            onChangeText={(val) => setFieldValue('notes', val)}
                          />
                        </Layout.FormGroup>
                        {values.cash_before_delivery ? (
                          <Layout.FormGroup>
                            <FormLabel label="Payment Proof" isRequired />
                            {values.payment_proof ? (
                              <View
                                style={{
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                }}>
                                <TouchableOpacity
                                  style={{ width: 36, marginRight: 10 }}
                                  onPress={() =>
                                    downloadFile(
                                      values.payment_proof,
                                      'payment-proof',
                                      '',
                                      true,
                                    )
                                  }>
                                  <Image
                                    style={{
                                      width: 32,
                                      height: 32,
                                    }}
                                    width={32}
                                    height={32}
                                    isResolveAsset
                                    source={require('@/assets/img/icons/attachment.png')}
                                  />
                                </TouchableOpacity>
                                <TouchableOpacity
                                  activeOpacity={0.6}
                                  onPress={async () => {
                                    dispatch(
                                      showAlert({
                                        show: true,
                                        title: 'Remove Payment Proof',
                                        description:
                                          'Are you sure you want to remove this attachment?',
                                        isConfirm: true,
                                        testID:
                                          'sales-order-form-remove-payment',
                                        onCallback: async () => {
                                          if (isEdit) {
                                            dispatch(
                                              showPopup({
                                                name: 'isLoading',
                                                value: true,
                                              }),
                                            );
                                            await MsOrder.deletePaymentProofOrder(
                                              detailData?._id,
                                            );
                                          }
                                          setFieldValue('payment_proof', '');
                                          dispatch(
                                            showPopup({
                                              name: 'isLoading',
                                              value: false,
                                            }),
                                          );
                                        },
                                      }),
                                    );
                                  }}>
                                  <Image
                                    style={{ width: 14, height: 18 }}
                                    width={14}
                                    height={18}
                                    source={require('@assets/img/icons/trash-grey.svg')}
                                    svg={true}
                                  />
                                </TouchableOpacity>
                              </View>
                            ) : (
                              <TouchableOpacity
                                style={styles.uploadPaymentProof}
                                onPress={async () => {
                                  const attach = await getDocumentAsync({
                                    copyToCacheDirectory: false,
                                  });
                                  if (!attach.canceled) {
                                    if (
                                      !isAllowedAttachmentFormat(
                                        attach.assets[0],
                                      )
                                    ) {
                                      dispatch(
                                        showAlert({
                                          show: true,
                                          title: ATTACHMENT_FORMAT_ERROR_TITLE,
                                          description:
                                            ATTACHMENT_FORMAT_ERROR_DESCRIPTION,
                                          isConfirm: false,
                                        }),
                                      );
                                      return;
                                    }
                                    dispatch(
                                      showPopup({
                                        name: 'isLoading',
                                        value: true,
                                      }),
                                    );
                                    try {
                                      const url = await uploadS3({
                                        file: attach?.assets[0] || {},
                                        isNeedMobileSupport: true,
                                      });
                                      if (url) {
                                        if (isEdit) {
                                          await MsOrder.updatePaymentProofOrder(
                                            detailData?._id,
                                            {
                                              payment_proof: url,
                                            },
                                          );
                                        }
                                        setFieldValue('payment_proof', url);
                                      } else {
                                        Toast.show({
                                          text1:
                                            'Failed to upload file. Please try again.',
                                          type: 'error',
                                        });
                                      }
                                      dispatch(
                                        showPopup({
                                          name: 'isLoading',
                                          value: false,
                                        }),
                                      );
                                    } catch (err) {
                                      Toast.show({
                                        text1: 'A system error occurred',
                                        type: 'error',
                                      });
                                      dispatch(
                                        showPopup({
                                          name: 'isLoading',
                                          value: false,
                                        }),
                                      );
                                    }
                                  }
                                }}>
                                <SociollaText type="medium">
                                  Upload
                                </SociollaText>
                              </TouchableOpacity>
                            )}
                          </Layout.FormGroup>
                        ) : (
                          false
                        )}
                        {isMobileWeb ? (
                          <View style={{ height: 250 }}></View>
                        ) : (
                          false
                        )}
                      </View>
                    </Layout.FormWrapper>
                  ) : (
                    false
                  )}
                  {page == 2 || isWeb ? (
                    <Layout.FormWrapper
                      style={{
                        paddingBottom: isAndroid
                          ? 220
                          : isIos
                          ? 170
                          : isMobileWeb
                          ? 190
                          : 0,
                      }}>
                      <TitleSectionForm
                        title="ATTACHMENTS"
                        buttonTitle={isWeb ? 'Add Attachment' : 'Add'}
                        disabled={values.attachment?.length >= 5}
                        onCallback={async () => {
                          const attach = await getDocumentAsync({
                            copyToCacheDirectory: false,
                          });
                          if (!attach.canceled) {
                            if (!isAllowedAttachmentFormat(attach.assets[0])) {
                              dispatch(
                                showAlert({
                                  show: true,
                                  title: ATTACHMENT_FORMAT_ERROR_TITLE,
                                  description:
                                    ATTACHMENT_FORMAT_ERROR_DESCRIPTION,
                                  isConfirm: false,
                                }),
                              );
                              return;
                            }
                            dispatch(
                              showPopup({ name: 'isLoading', value: true }),
                            );
                            try {
                              const file = attach?.assets[0] || {};
                              const attachmentCounter =
                                (values?.attachment?.length || 0) + 1;
                              const refCode = (
                                detailData?.reference_code ||
                                props?.route?.params?.titleScreen ||
                                ''
                              ).replace(/\//g, '-');
                              const fileName = `Attachment_${
                                refCode || 'SO'
                              }_${attachmentCounter}`;
                              const nameParts = (file?.name || '').split('.');
                              const mimeExtMap = {
                                'image/jpeg': 'jpg',
                                'image/jpg': 'jpg',
                                'image/png': 'png',
                                'image/gif': 'gif',
                                'application/pdf': 'pdf',
                              };
                              const ext =
                                (nameParts.length > 1
                                  ? nameParts[nameParts.length - 1]
                                  : '') ||
                                (file?.mimeType
                                  ? mimeExtMap[file.mimeType] || ''
                                  : '');
                              file.name = `${Date.now()}_${fileName}`;
                              if (isNative && ext) {
                                file.name = `${file.name}.${ext}`;
                              }
                              const url = await uploadS3({
                                file,
                                isNeedMobileSupport: true,
                                isRename: true,
                                isReplaceFile: true,
                              });
                              if (url) {
                                const newFile = {
                                  name: ext ? `${fileName}.${ext}` : fileName,
                                  url: url,
                                };
                                const files = JSON.parse(
                                  JSON.stringify(values.attachment),
                                );
                                files.push(newFile);
                                if (newFile?.url && isEdit) {
                                  const attachResponse =
                                    await MsOrder.createAttachmentOrder(
                                      detailData?._id,
                                      newFile,
                                    );
                                  if (attachResponse?.data?.data?.attachments) {
                                    setFieldValue(
                                      'attachment',
                                      attachResponse.data.data.attachments,
                                    );
                                  }
                                } else {
                                  setFieldValue('attachment', files);
                                }
                              } else {
                                Toast.show({
                                  text1:
                                    'Failed to upload file. Please try again.',
                                  type: 'error',
                                });
                              }
                              dispatch(
                                showPopup({ name: 'isLoading', value: false }),
                              );
                            } catch (err) {
                              Toast.show({
                                text1: 'A system error occurred',
                                type: 'error',
                              });
                              dispatch(
                                showPopup({ name: 'isLoading', value: false }),
                              );
                            }
                          }
                        }}
                      />
                      <View style={styles.documentWrapper}>
                        {values?.attachment?.length ? (
                          <View
                            style={[
                              styles.attachment,
                              values.attachment.length < 3
                                ? { justifyContent: 'flex-start' }
                                : {},
                            ]}>
                            {values.attachment.map((item, idx) => (
                              <TouchableOpacity
                                activeOpacity={0.8}
                                style={styles.attachmentItem}
                                key={idx}
                                onPress={() => onDownloadAttachment(item.url)}>
                                <RemoveImage
                                  index={idx}
                                  data={values.attachment}
                                  conpywriting={{
                                    title: 'Remove Attachment',
                                    description:
                                      'Are you sure you want to remove this file?',
                                  }}
                                  setData={async (val) => {
                                    if (
                                      isEdit &&
                                      values.attachment?.length &&
                                      idx > -1
                                    ) {
                                      const removeItem = JSON.parse(
                                        JSON.stringify(values.attachment[idx]),
                                      );
                                      await MsOrder.removeAttachmentOrder(
                                        detailData?._id,
                                        removeItem?._id,
                                      );
                                    }
                                    setFieldValue('attachment', val);
                                  }}
                                />
                                <Image
                                  style={[
                                    styles.attachmentIcon,
                                    { width: 40, height: 40 },
                                  ]}
                                  width={40}
                                  height={40}
                                  isResolveAsset
                                  source={require('@/assets/img/icons/attachment.png')}
                                />
                                <View style={styles.attachmentTextWrapper}>
                                  <SociollaText style={styles.attachmentText}>
                                    {item.name}
                                  </SociollaText>
                                </View>
                              </TouchableOpacity>
                            ))}
                          </View>
                        ) : (
                          <SociollaText>No document attached.</SociollaText>
                        )}
                      </View>
                      {isWeb ? (
                        <TitleSectionForm
                          testID="sales-order-form-order-lines-section"
                          title={`ORDER LINES (${productCount})`}
                          buttonTitle="Add Product"
                          showButton={showAddProductButton(values)}
                          onCallback={() => onAddProduct()}
                          buttonTitleChild="Import CSV"
                          onCallbackChild={() =>
                            dispatch(
                              showPopup({
                                name: 'showImportModalSOProduct',
                                value: true,
                              }),
                            )
                          }
                        />
                      ) : products?.length ? (
                        <View
                          style={{
                            width: '100%',
                            marginVertical: 10,
                            flexDirection: 'row-reverse',
                            paddingHorizontal: 30,
                          }}>
                          <SociollaText>
                            Total Product: {productCount}
                          </SociollaText>
                        </View>
                      ) : (
                        false
                      )}
                      <View
                        style={{
                          width: '100%',
                          paddingHorizontal: isWeb ? 30 : 0,
                          ...(isWeb ? { paddingVertical: 20 } : {}),
                        }}>
                        {products?.length ? (
                          (products || []).map((item, idx) => {
                            const nonFreeProduct =
                              item.product_type == 'gwp_levelling_free_product';
                            if (nonFreeProduct) {
                              return null;
                            }
                            return (
                              <ProductItem
                                testID={`sales-order-form-product-item-${idx}`}
                                isCopyItem={true}
                                isQuotation={isQuotation}
                                isShowDiscount2={true}
                                data={item}
                                orderId={detailData?._id}
                                onShow={() => onAddProduct(item)}
                                onRemove={() => onRemoveProduct(idx)}
                                customer={selectedCustomer}
                                isShowStock={true}
                                sales_team={selectedSalesTeam}
                                onSelectPromo={async (val) => {
                                  await handleProductSelectPromo(val, idx);
                                }}
                                onCancelPromo={async () => {
                                  await handleCancelPromo(idx);
                                }}
                                showRemove={!isQuotation}
                                key={idx}
                                setDetailPromoData={(val) => {
                                  setDetailPromoData(val);
                                }}
                                isShowDetailPromo={true}
                              />
                            );
                          })
                        ) : !loadingAddProduct ? (
                          <View
                            style={{
                              paddingVertical: 20,
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}>
                            <Image
                              style={{ width: 30, height: 35 }}
                              width={30}
                              height={35}
                              source={require('@assets/img/icons/no-product.svg')}
                              svg={true}
                            />
                            <SociollaText style={{ marginVertical: 10 }}>
                              No product found
                            </SociollaText>
                            {!isWeb && showAddProductButton(values) ? (
                              <View
                                style={{
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                }}>
                                <Button
                                  testID="sales-order-form-add-product-btn-mobile"
                                  type="default"
                                  rounded
                                  buttonStyle={{
                                    width: 150,
                                    marginBottom: 10,
                                  }}
                                  disabledStyle={{
                                    width: 150,
                                    marginBottom: 10,
                                  }}
                                  title={
                                    <SociollaText
                                      type="bold"
                                      style={{
                                        fontSize: 14,
                                        letterSpacing: 0.5,
                                        color: Colors.black,
                                      }}>
                                      Add Product
                                    </SociollaText>
                                  }
                                  onPress={() => onAddProduct()}
                                />
                                <Button
                                  testID="sales-order-form-import-csv-btn-mobile"
                                  type="default"
                                  rounded
                                  buttonStyle={{ width: 150 }}
                                  title={
                                    <SociollaText
                                      type="bold"
                                      style={{
                                        fontSize: 14,
                                        letterSpacing: 0.5,
                                        color: Colors.black,
                                      }}>
                                      Import CSV
                                    </SociollaText>
                                  }
                                  onPress={() =>
                                    dispatch(
                                      showPopup({
                                        name: 'showImportModalSOProduct',
                                        value: true,
                                      }),
                                    )
                                  }
                                />
                              </View>
                            ) : (
                              false
                            )}
                          </View>
                        ) : (
                          false
                        )}
                        {loadingAddProduct ? (
                          <View
                            style={{
                              flexDirection: 'row',
                              alignItems: 'center',
                              justifyContent: 'center',
                              paddingVertical: 15,
                            }}>
                            <Layout.Loader />
                          </View>
                        ) : (
                          false
                        )}
                        {isEdit &&
                        !priceRulesChange &&
                        skip <= products?.length &&
                        products?.length >= limit ? (
                          <View
                            style={{
                              width: '100%',
                              paddingVertical: 15,
                              alignItems: 'center',
                            }}>
                            <Button
                              rounded
                              buttonStyle={{
                                width: isWeb ? 150 : dimension.width - 30,
                              }}
                              title={
                                <SociollaText
                                  type="bold"
                                  style={{
                                    fontSize: 14,
                                    letterSpacing: 0.5,
                                    color: Colors.white,
                                  }}>
                                  Load More
                                </SociollaText>
                              }
                              onPress={() =>
                                getProductSalesOrder(
                                  detailData?._id,
                                  skip + limit,
                                )
                              }
                            />
                          </View>
                        ) : (
                          false
                        )}
                      </View>
                      {products?.some(
                        (item) =>
                          item.product_type == 'gwp_levelling_free_product',
                      ) ? (
                        <>
                          <TitleSectionForm
                            title={'FREE PRODUCT'}
                            showButton={false}
                          />

                          <View
                            style={{
                              width: '100%',
                              paddingHorizontal: isWeb ? 30 : 0,
                              ...(isWeb
                                ? { paddingVertical: 20 }
                                : {
                                    marginTop: 2,
                                  }),
                            }}>
                            {products
                              ?.filter(
                                (item) =>
                                  item.product_type ==
                                  'gwp_levelling_free_product',
                              )
                              .map((product, index) => (
                                <ProductItem
                                  isCopyItem={true}
                                  isQuotation={isQuotation}
                                  isShowDiscount2={true}
                                  data={product}
                                  orderId={detailData?._id}
                                  onShow={() => onAddProduct(product)}
                                  onRemove={() => onRemoveProduct(index)}
                                  customer={selectedCustomer}
                                  isShowStock={true}
                                  sales_team={selectedSalesTeam}
                                  onSelectPromo={async (val) => {
                                    await handleProductSelectPromo(val, index);
                                  }}
                                  onCancelPromo={async () => {
                                    await handleCancelPromo(index);
                                  }}
                                  showRemove={!isQuotation}
                                  key={index}
                                  setDetailPromoData={(val) => {
                                    setDetailPromoData(val);
                                  }}
                                  isShowDetailPromo={true}
                                />
                              ))}
                          </View>
                        </>
                      ) : null}
                      <Divider />
                      <View
                        style={{
                          width: '100%',
                          paddingVertical: 10,
                          paddingHorizontal: isWeb ? 40 : 15,
                          ...(isAndroid ? { marginBottom: 30 } : {}),
                        }}>
                        <View
                          style={{
                            flexDirection: 'row',
                            alignItems: 'center',
                          }}>
                          <ItemDetail
                            between={true}
                            name="Subtotal"
                            value={currency(subTotal, true)}
                            valueStyle={{ width: 'unset' }}
                          />
                        </View>
                        <View
                          style={{
                            flexDirection: 'row',
                            alignItems: 'center',
                          }}>
                          {isQuotation && (
                            <ItemDetail
                              between={true}
                              nameStyle={{
                                color: isQuotationAmountDiff(
                                  detailData.quotation_subtotal,
                                  detailData.subtotal,
                                )
                                  ? Colors.red0
                                  : Colors.green1,
                              }}
                              name="Subtotal Quotation"
                              value={currency(
                                detailData.quotation_subtotal,
                                true,
                              )}
                              valueStyle={{
                                color: isQuotationAmountDiff(
                                  detailData.quotation_subtotal,
                                  subTotal,
                                )
                                  ? Colors.red0
                                  : Colors.green1,
                                width: 'unset',
                              }}
                            />
                          )}
                        </View>
                        <View
                          style={{
                            flexDirection: 'row',
                            alignItems: 'center',
                          }}>
                          <ItemDetail
                            between={true}
                            name="Taxes"
                            value={currency(taxes, true)}
                            valueStyle={{ width: 'unset' }}
                          />
                        </View>
                        <View
                          style={{
                            flexDirection: 'row',
                            alignItems: 'center',
                          }}>
                          {isQuotation && isWeb && (
                            <ItemDetail
                              between={true}
                              nameStyle={{
                                color: isQuotationAmountDiff(
                                  detailData.quotation_tax,
                                  detailData.taxes,
                                )
                                  ? Colors.red0
                                  : Colors.green1,
                              }}
                              name="Taxes Quotation"
                              value={currency(detailData.quotation_tax, true)}
                              valueStyle={{
                                color: isQuotationAmountDiff(
                                  detailData.quotation_tax,
                                  taxes,
                                )
                                  ? Colors.red0
                                  : Colors.green1,
                                width: 'unset',
                              }}
                            />
                          )}
                        </View>
                        <View
                          style={{
                            flexDirection: 'row',
                            alignItems: 'center',
                          }}>
                          <ItemDetail
                            between={true}
                            name="TOTAL"
                            nameBold={true}
                            nameStyle={{ color: Colors.blue0 }}
                            value={currency(total, true)}
                            valueBold={true}
                            valueStyle={{ color: Colors.blue1, width: 'unset' }}
                            withoutBorder={!isQuotation}
                          />
                        </View>
                        <View
                          style={{
                            flexDirection: 'row',
                            alignItems: 'center',
                          }}>
                          {isQuotation && (
                            <ItemDetail
                              between={true}
                              nameStyle={{
                                color: isQuotationAmountDiff(
                                  detailData.quotation_subtotal,
                                  detailData.subtotal,
                                )
                                  ? Colors.red0
                                  : Colors.green1,
                              }}
                              withoutBorder={true}
                              name="TOTAL Quotation"
                              value={currency(detailData.quotation_total, true)}
                              valueBold={true}
                              valueStyle={{
                                color: isQuotationAmountDiff(
                                  detailData.quotation_total,
                                  detailData.total_amount,
                                )
                                  ? Colors.red0
                                  : Colors.green1,
                                width: 'unset',
                              }}
                            />
                          )}
                        </View>
                      </View>
                      {isMobileWeb ? (
                        <View
                          style={{
                            height:
                              productCount < 2 ? 400 : (productCount + 1) * 120,
                          }}></View>
                      ) : (
                        false
                      )}
                    </Layout.FormWrapper>
                  ) : (
                    false
                  )}
                </ScrollView>
              </Layout.Wrapper>
              {!isWeb && !isLoadingPage ? (
                <Layout.ButtonSticky
                  testID={`sales-order-form-sticky-btn-page-${page}`}
                  show={
                    props?.route?.name == 'SalesOrderFormScreen' &&
                    [1, 2].includes(page)
                  }
                  route={props?.route}
                  buttons={
                    page == 1
                      ? [
                          {
                            title: 'Next',
                            disabled: (() => {
                              const fields = {
                                sales_team: 'Sales Team',
                                warehouse: 'Warehouse',
                                sales_person: 'Sales Person',
                              };

                              const emptyFields = Object.entries(fields)
                                .filter(([key]) => isEmpty(values[key]))
                                .map(([, label]) => label);

                              return (
                                !showAddProductButton(values) ||
                                !isFilledDeliveryAddress(values) ||
                                emptyFields.length > 0
                              );
                            })(),
                            onPress: () => setPage(2),
                          },
                        ]
                      : page == 2
                      ? [
                          ...(products &&
                          products.length &&
                          showAddProductButton(values)
                            ? [
                                {
                                  title: 'Add Product',
                                  type: 'default',
                                  onPress: () => onAddProduct(),
                                },
                                {
                                  title: 'Import CSV',
                                  type: 'default',
                                  onPress: () =>
                                    dispatch(
                                      showPopup({
                                        name: 'showImportModalSOProduct',
                                        value: true,
                                      }),
                                    ),
                                },
                              ]
                            : []),
                          {
                            title:
                              isEdit || !products.length
                                ? 'Save'
                                : 'Request Confirmation',
                            onPress: (evt) => {
                              evt.persist();
                              if (!isEdit && products.length) {
                                setFieldValue('status', 'need_approval');
                                onChangeFilter();
                              }
                              setTimeout(() => {
                                validateForm().then((validate) => {
                                  handleSubmit(evt);
                                  if (
                                    validate &&
                                    Object.keys(validate).length
                                  ) {
                                    setPage(1);
                                  }
                                });
                              }, 100);
                            },
                          },
                        ]
                      : []
                  }
                />
              ) : (
                false
              )}
            </>
          )}
        </Formik>
      )}
      <Alert />
      <Discard />
      <ModalFull
        title={'Terms and Conditions'}
        show={!!detailPromoData}
        onClose={() => {
          setDetailPromoData(null);
        }}>
        <ScrollContainer
          style={{
            maxHeight: dimension.height * (isWeb ? 0.2 : 0.9),
          }}>
          <View
            style={{
              padding: 20,
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
            }}>
            <SociollaText
              style={{
                fontSize: 12,
                lineHeight: 20,
                paddingBottom: 15,
                borderBottomWidth: 1,
                borderBottomColor: '#E8E8E8',
                whiteSpace: 'pre-line',
              }}>
              {detailPromoData?.description}
            </SociollaText>

            <SociollaText
              style={{
                fontSize: 10,
                lineHeight: 20,
                color: '#BDC1C9',
              }}>
              Period : {parseDate(detailPromoData?.from_date)} -{' '}
              {parseDate(detailPromoData?.to_date)}
            </SociollaText>
          </View>
        </ScrollContainer>
      </ModalFull>
      <ModalFull
        title={'Select Promotion'}
        show={!!gwpProductOption}
        onClose={() => {
          setGwpProductOption(null);
          setSelectedOption(null);
          setIndexGwpProduct(null);
        }}>
        <ScrollContainer
          style={{
            maxHeight: dimension.height * (isWeb ? 0.6 : 0.9),
          }}>
          <View style={styles.container}>
            {gwpProductOption?.map((bundle, idx) => (
              <View key={bundle._id} style={styles.optionBlock}>
                <TouchableOpacity
                  style={styles.optionHeader}
                  onPress={() => setSelectedOption(idx)}>
                  <View
                    style={[
                      styles.radio,
                      selectedOption === idx && styles.radioSelected,
                    ]}
                  />
                  <SociollaText style={styles.optionTitle}>
                    Option {idx + 1}
                  </SociollaText>
                </TouchableOpacity>

                <TouchableOpacity onPress={() => setSelectedOption(idx)}>
                  {bundle.products.map((p) => (
                    <View key={p?._id} style={styles.productRow}>
                      <Image source={{ uri: p?.image }} style={styles.image} />
                      <View style={{ flex: 1 }}>
                        <SociollaText style={styles.sku} type="medium">
                          {p?.sku}
                        </SociollaText>
                        <SociollaText type="medium">{p?.name}</SociollaText>
                        <SociollaText style={styles.meta}>
                          {p?.brand?.name}
                        </SociollaText>
                        <SociollaText style={styles.meta}>
                          {p?.quantity} Pcs
                        </SociollaText>
                      </View>
                    </View>
                  ))}
                </TouchableOpacity>
              </View>
            ))}

            <TouchableOpacity
              style={[
                styles.selectButton,
                selectedOption === null && { backgroundColor: '#BDC1C9' },
              ]}
              disabled={selectedOption === null}
              onPress={async () => {
                await handleProductSelectPromo(
                  productPromo,
                  indexGwpProduct,
                  true,
                  selectedOption,
                );
                setGwpProductOption(null);
                setSelectedOption(null);
                setIndexGwpProduct(null);
              }}>
              <SociollaText style={styles.selectButtonText} type="bold">
                Select
              </SociollaText>
            </TouchableOpacity>
          </View>
        </ScrollContainer>
      </ModalFull>
      <AddProduct
        testID="sales-order-form-add-product-modal"
        isQuotation={isQuotation}
        show={showAddProduct}
        detail={productDetail}
        products={products}
        RulesTaxType={RulesTaxTypes}
        priceRulesId={priceRulesId}
        regularDiscount={selectedRegularDiscount}
        cashBeforeDelivery={selectedCashBeforeDelivery}
        selectedCustomer={selectedCustomer}
        selectedSalesTeam={selectedSalesTeam}
        activityId={activityId}
        orderId={detailData?._id ? detailData._id : orderId}
        onClose={() => onCloseProduct()}
        setProducts={async ({ val, index }) => {
          await handleSetProducts({ val, index });
        }}
      />
      <ModalUpload
        testID="sales-order-form-import-product-modal"
        show={showImportModalSOProduct}
        onClose={() =>
          dispatch(
            showPopup({
              name: 'showImportModalSOProduct',
              value: false,
            }),
          )
        }
        templateUrl={templateSoProduct}
        onUpload={onUploadBulkProduct}
        autoUploadS3={false}
        name={'sales_order_product'}
        validHeader={['reference_ean', 'quantity', 'taxes.type']}
      />
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  documentWrapper: {
    width: '100%',
    padding: 15,
    ...(!isWeb
      ? { borderBottomWidth: 1, borderBottomColor: Colors.grey0 }
      : {}),
  },
  attachment: {
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
    ...(!isWeb ? { justifyContent: 'space-between' } : {}),
  },
  attachmentItem: {
    width: isWeb ? 100 : '30%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 8,
    borderWidth: 1,
    borderColor: Colors.grey0,
    borderRadius: 4,
    marginRight: 10,
    marginBottom: 10,
  },
  attachmentIcon: {
    marginBottom: 10,
  },
  attachmentTextWrapper: {
    flexDirection: 'wrap',
    width: '100%',
  },
  attachmentText: {
    fontSize: 13,
    textAlign: 'center',
  },
  uploadPaymentProof: {
    width: 150,
    paddingVertical: 8,
    paddingHorizontal: 15,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Colors.grey0,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    padding: 16,
  },
  optionBlock: {
    marginBottom: 24,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    paddingBottom: 16,
  },
  optionHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  optionTitle: {
    fontWeight: '600',
    marginLeft: 8,
  },
  radio: {
    width: 12,
    height: 12,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: '#0028E4',
  },
  radioSelected: {
    backgroundColor: '#0028E4',
  },
  productRow: {
    flexDirection: 'row',
    marginBottom: 12,
    paddingLeft: 20,
  },
  image: {
    width: 48,
    height: 48,
    borderRadius: 4,
    marginRight: 12,
    borderWidth: 1,
    borderColor: '#eee',
  },
  sku: {
    fontWeight: '500',
  },
  meta: {
    color: '#666',
    fontSize: 12,
  },
  selectButton: {
    backgroundColor: '#0028E4',
    paddingVertical: 12,
    borderRadius: 6,
    alignItems: 'center',
  },
  selectButtonText: {
    color: '#fff',
    fontWeight: '600',
  },
});

export default SalesOrderFormScreen;
